<template>
    <div>

    <div class="alert alert-secondary text-center" role="alert">No active subscriptions</div>

      <div class="card">
    <div class="card-body pb-0">

      <div v-if="loading"></div> <!-- do nothing -->

        <div v-else>

          <!-- Desktop -->
          <table class="datatables-basic table d-none d-md-table">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="25%">Plan</th>
                  <th class="pl-3" width="25%">Websites</th>
                  <th class="pl-3" width="25%">Monthly</th>
                  <th class="first-right pl-3" width="25%"></th>
                </tr>
              </thead>
          <tbody>
            <tr class="body2" v-for="(product, index) in products" :key="index.id">
              <td class="pl-3">{{product.name}}</td>
              <td class="pl-3">{{product.sites}}</td>
              <td class="pl-3"><span class="font-weight-bold">{{formattedPrice(product.price)}}</span></td>           
              <td class="pl-3"><a :href="`/subscriptions/buy/${product.id}`" class="btn btn-danger">Buy Now</a></td>           
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Product • Amount</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(product, index) in products" :key="index">
  
        <td class="pl-2 text-center">
            <div><b>{{product.name}}</b></div>
            <div>{{formattedPrice(product.price)}} /month</div>
            <div class="py-2"><a :href="`/subscriptions/buy/${product.id}`" class="btn btn-danger">Buy Now</a></div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
  </div>
  </div>
</template> 

<script>

export default {
  
props: [],

  data() {
    return {
      products: [],
      loading: true,
    };
  },

  created() {
    this.getProducts();
  },

  methods: {

    getProducts() {

      axios.get('/subscriptions/get-products').
      then((response) => {
        this.products = response.data;
        this.loading = false;
      });
    },

  },
};
</script>